import React from 'react';
import InclusionHeaderRow from '../common/InclusionHeaderRow';
import InclusionDetailCard from '../common/InclusionDetailCard';

const AirportTransferInclusion = ({
    disabled,
    isAirportTransferIncluded,
    airportSightseeinglistdata,
    airportSightseeingDetail,
    handletransfersightseeingchange,
    airportSightseeingdisable,
    airportSightseeingopen,
    handleTransferSightseeing,
}) => {
    return (
        <>
            <InclusionHeaderRow
                label="Add Airport Transfers"
                required={isAirportTransferIncluded}
                datalist={airportSightseeinglistdata}
                fieldid={airportSightseeingDetail?.AirportSightseeingId}
                onSelectionChange={(e) => handletransfersightseeingchange(e, 'AirportTransfer')}
                isDisabled={disabled || !isAirportTransferIncluded}
                isActiveDisable={airportSightseeingdisable}
                isSearchable
                isOpen={airportSightseeingopen}
                onToggle={() => handleTransferSightseeing("AirportTransfer")}
                buttonDisabled={!isAirportTransferIncluded}
            />

            {airportSightseeingopen && (
                <InclusionDetailCard
                    title={airportSightseeingDetail?.AirportSightseeingName}
                    pickupPoint={airportSightseeingDetail?.AirportSightseeingPickupPoint}
                    dropPoint={airportSightseeingDetail?.AirportSightseeingDropPoint}
                    duration={airportSightseeingDetail?.AirportSightseeingDuration}
                    itineraryDetails={airportSightseeingDetail?.AirportSightseeingItineraryDetails}
                    timePickerId="AirportSightseeingDuration"
                />
            )}
        </>
    );
};

export default React.memo(AirportTransferInclusion);

